import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, } from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import CreateLocation from './CreateLocation';
class CreateLocationModal extends React.Component {
    render() {
        return (React.createElement(Dialog, { open: this.props.show, onOpenChange: this.props.onHide },
            React.createElement(DialogContent, { className: "sm:max-w-[700px] max-h-[90vh] overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, this.props.t('CREATE_LOCATION'))),
                React.createElement(CreateLocation, { onCreate: this.props.onCreate, onCreateLocationCancel: this.props.onHide, error: this.props.error, locationPending: this.props.locationPending }))));
    }
}
export default withTranslation()(CreateLocationModal);
